
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spa-and-salon/dermatology-pos-billing-software",
      function () {
        return require("private-next-pages/spa-and-salon/dermatology-pos-billing-software.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spa-and-salon/dermatology-pos-billing-software"])
      });
    }
  